<template lang="html">
    <div class="art-buyers">
        <div class="col-twelve text-left">
            <input type="file" accept="image/png,image/jpeg" name="image" v-on:change="uploadImage" id="new-buyer">
            <button class="big-purple-button" @click="chooseImage">Upload</button>
            <div class="message">{{ errorText }}</div>
        </div>
        <div class="buyers-wrapper col-twelve no-padding-left no-padding-right">
            <art-buyer v-for="buyer in buyers" :buyer="buyer" :key="buyer.id" @buyerDeleted="deleteBuyer"></art-buyer>
        </div>
    </div>
</template>

<script>
// Component to show and control list of art buyers

export default {
  props: ['default'],
  data() {
    return {
      buyers: [],
      errorText: ''
    };
  },
  methods: {
    deleteBuyer(deletedBuyer) {
      this.buyers = this.buyers.filter((buyer) => {
        return buyer.id !== deletedBuyer.id;
      });
    },
    chooseImage() {
      window.$('.art-buyers input[type=file]').click();
    },
    uploadImage() {
      if(!$('#new-buyer').val()){
        return false;
      }
      let formData = new FormData();
      let image = document.getElementById('new-buyer').files[0];
      if ( !image.type.match('image.*')) {
        return false;
      }
      formData.append('image', image);
      axios.post('/admin/ajax/upload/buyer', formData,
        {
          headers: { 'content-type': 'multipart/form-data' }
        })
        .then((response) => {
          this.errorText = '';
          window.$('.art-buyers .message').removeClass('text-danger');
          this.buyers.push(response.data);
          let masonry = window.$('.masonry').data('masonry');
          $('#new-buyer').val('');
        }).catch(() => {
          this.errorText = 'Please upload correct image (.JPG, .PNG, 700x700px minimum)';
          window.$('.art-buyers .message').addClass('text-danger');
          $('#new-buyer').val('');
        });
    }
  },
  mounted() {
    if (this.default) {
      this.default.forEach((buyer) => {
        this.buyers.push(buyer);
      });
    }
  }
};
</script>

<style lang="scss">
    .art-buyers {
        margin-top: 15px;
        input[type=file] {
            display: none;
        }
        .message {
            vertical-align: middle;
            display: inline-block;
        }
        .buyers-wrapper {
            margin-top: 15px;
        }
    }
</style>